"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
exports.Checkbox = function (_a) {
    var disableRipple = _a.disableRipple, rest = tslib_1.__rest(_a, ["disableRipple"]);
    return (react_1.default.createElement(StyledCheckbox, tslib_1.__assign({}, rest, { disableRipple: true, classes: {
            root: 'fos-checkbox-root',
            checked: 'fos-checkbox-root-checked',
            indeterminate: 'fos-checkbox-root-indeterminate',
        } })));
};
var StyledCheckbox = styled_components_1.default(core_1.Checkbox)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    &.fos-checkbox-root {\n      &:hover {\n        background: none;\n      }\n\n      &.fos-checkbox-root-checked,\n      &.fos-checkbox-root-indeterminate {\n        color: ", ";\n      }\n\n      color: ", ";\n      padding: 0rem;\n    }\n  }\n"], ["\n  && {\n    &.fos-checkbox-root {\n      &:hover {\n        background: none;\n      }\n\n      &.fos-checkbox-root-checked,\n      &.fos-checkbox-root-indeterminate {\n        color: ", ";\n      }\n\n      color: ", ";\n      padding: 0rem;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[300];
});
exports.Checkbox.displayName = 'FOS__Checkbox';
exports.default = exports.Checkbox;
var templateObject_1;
